import React from 'react';
import { CardSeparatorWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var CardSeparator = function CardSeparator() {
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(CardSeparatorWrapper, {
    "data-testid": "separator",
    theme: theme
  });
};
process.env.NODE_ENV !== "production" ? CardSeparator.displayName = 'CardSeparator' : void 0;
var CardSeparator$1 = CardSeparator;

export { CardSeparator$1 as default };
